






















import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { ProvisionRequestStatusCodes as PRSC } from "@/data/enums/contractProducts";
import { DataModules } from "@/store/modules/data";

// Types
import { IProvisionRequest } from "@/models/provisioning";

@Component
export default class ContractProductRequestModal extends Vue {
  // Props

  @Prop({ required: true })
  public request!: IProvisionRequest;

  @Prop({ required: true })
  public canCancel!: boolean;

  // Methods

  public async openCancelRequestConfirm() {
    if (!this.canCancel) return;

    this.$store.dispatch(
      `data/${DataModules.PROVISIONING_CONTRACT_PRODUCTS}/openCancelRequestModal`,
      {
        requestId: this.request.id,
        onSuccess: async () => {
          this.$emit("close");
          this.$bus.$emit("refreshRequestTable");
        }
      }
    );
  }

  // Computed

  public get path() {
    switch (this.request.status?.code) {
      case PRSC.PROVISION_REQUEST_PENDING:
        return "_sentence.cancel_pending_request_msg";
      case PRSC.PROVISION_REQUEST_DRAFT:
        return "_sentence.cancel_draft_request_msg";
      case PRSC.PROVISION_REQUEST_SCHEDULED:
        return "_sentence.cancel_scheduled_request_msg";
      default:
        return "_sentence.cancel_dispatched_request_msg";
    }
  }

  public get message() {
    return this.$_.get(this.request, "results[0].message", null);
  }
}
